import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
import { AppProvider } from '../../assets/js/react/components/booking/store';
const BookingAssociation = lazy(() => import("../../assets/js/react/components/booking/association"));

CreateRoot(
  'booking-association',
  <AppProvider>
    <BookingAssociation />
  </AppProvider>,
);
